import { settingsWindowItem } from "@/appInterface/windows/settingsWindow/settingsWindowItem.js";
import { canv } from "@/canv/global.js";
import { MakeRequest, getTarget } from "@/canv/utils.js";
import { eventEmitter } from "@/eventEmitter";
import { selectionManager } from "@/tools/cursorTool";
import { loadFiles, pasteProccessor } from "@/canvasController/helpers";

export class settingsWindow {
    constructor() { }

    prepare(panelLevel, codeName) {
        this.panelLevel = panelLevel;
        this.items = this.getUnionByCodeName(codeName);
    }

    show(alignBy) {
        let settingsWindowWrapper = document.getElementsByClassName(
            "settingsWindowWrapper",
        )[0];
        if (settingsWindowWrapper == undefined) {
            settingsWindowWrapper = document.createElement("div");
            settingsWindowWrapper.classList.add("settingsWindowWrapper");
            document.body.prepend(settingsWindowWrapper);
            this.initWrapper();
        }

        var settingsWindow = document.createElement("div");
        settingsWindow.classList.add("settingsWindow");
        settingsWindow.classList.add("settingsWindow_" + this.panelLevel);
        settingsWindowWrapper.prepend(settingsWindow);

        var template = ``;

        for (var i = 0; i < this.items.length; i++) {
            template += this.items[i].getTempalate();
        }

        settingsWindow.innerHTML = template;

        if (alignBy == null) {
            const barPanelSettings =
                document.getElementsByClassName("barPanelSettings")[0];
            const barPanelCenterSettingsDims =
                barPanelSettings.getBoundingClientRect();

            const settingsWindowDims = settingsWindow.getBoundingClientRect();
            settingsWindow.style.left =
                (
                    barPanelCenterSettingsDims.left +
                    barPanelCenterSettingsDims.width / 2 -
                    settingsWindowDims.width / 2
                ).toString() + "px";
        } else {
            const alignByDims = alignBy.getBoundingClientRect();

            const settingsWindowDims = settingsWindow.getBoundingClientRect();
            settingsWindow.style.left =
                (alignByDims.left + alignByDims.width + 10).toString() + "px";
            settingsWindow.style.top = (alignByDims.top - 10).toString() + "px";
        }

        this.init();

        eventEmitter.dispatch('header.button.active.name', {
            name: "settings",
        });
    }

    initWrapper() {
        // wrapper
        const settingsWindowWrapper = document.getElementsByClassName(
            "settingsWindowWrapper",
        )[0];
        settingsWindowWrapper.addEventListener(
            "mousedown",
            this.wrapperClick.bind(this),
            false,
        );
    }

    wrapperClick(e) {
        var tryInner = getTarget(e, "settingsWindow");
        if (tryInner == null) {
            this.close();
        }
    }

    close() {
        this.hide();
        const settingsWindowWrapper = document.getElementsByClassName(
            "settingsWindowWrapper",
        )[0];
        settingsWindowWrapper.outerHTML = ""

        eventEmitter.dispatch('header.button.active.name', {
            name: null,
        });
    }

    init() {
        var items = document.getElementsByClassName(
            "settingsWindowItem_" + this.panelLevel,
        );

        for (var i = 0; i < items.length; i++) {
            items[i].removeEventListener(
                "mouseover",
                this.itemHover.bind(this),
                false,
            );
            items[i].addEventListener("mouseover", this.itemHover.bind(this), false);

            items[i].removeEventListener(
                "mousedown",
                this.itemClick.bind(this),
                false,
            );
            items[i].addEventListener("mousedown", this.itemClick.bind(this), false);
        }
    }

    itemHover(e) {
        var itemOb = getTarget(e, "settingsWindowItem");
        var codeName = itemOb.getAttribute("codeName");

        var relevItems = this.getUnionByCodeName(codeName);

        if (this.childPanel != null) {
            this.childPanel.hide();
            this.childPanel = null;
        }

        if (relevItems.length != 0) {
            this.childPanel = new settingsWindow();
            this.childPanel.prepare(this.panelLevel + 1, codeName);
            this.childPanel.show(itemOb);
        }
    }

    itemClick(e) {
        var itemOb = getTarget(e, "settingsWindowItem");
        var codeName = itemOb.getAttribute("codeName");

        if (this.childPanel != null) {
            this.childPanel.hide();
            this.childPanel = null;
        }

        if (codeName == "share" || codeName == "shortcuts") {
            this.callProccessorByName(codeName);
        } else {
            this.callProccessorByName(codeName);
        }
    }

    hide() {
        var panel = document.getElementsByClassName(
            "settingsWindow_" + this.panelLevel,
        )[0];
        if (panel != undefined) {
            panel.outerHTML = "";
        }

        if (this.childPanel != null) {
            this.childPanel.hide();
            this.childPanel = null;
        }
    }

    // proccessors

    callProccessorByName(name) {
        if (name == "placeImage") {
            this.placeImageProccessor();
        } else if (name == "share") {
            canv.appInterface.shareWindow.open({
                mode: "board",
                token: canv.getInitDataProp("userToken"),
                accessSelector: canv.appInterface.accessMenu.open.bind(
                    canv.appInterface.accessMenu,
                ),
                host: canv.host,
                HTTPRequest: MakeRequest,
                stateChange: () => { },
                notificator: canv.appInterface.infoWindow.open.bind(
                    canv.appInterface.infoWindow,
                ),
                searchInputState: (state) => {
                    canv.appInterface.inputFocused = state;
                },

                boardUID: canv.getInitDataProp("boardUID"),
                onlyRead: canv.getInitDataProp("onlyRead"),
            });
            this.close();
        } else if (name == "shortcuts") {
            canv.appInterface.shortcutsWindow.show();
            this.close();
        } else if (name == "undo") {
            canv.eventManager.Undo();
        } else if (name == "redo") {
            canv.eventManager.Redo();
        } else if (name == "copy") {
            canv.canvasController.copyProccessor();
        } else if (name == "paste") {
            pasteProccessor();
        } else if (name == "duplicate") {
            canv.canvasController.duplicateProccessor();
        } else if (name == "selectAll") {
            selectionManager.setSelected(canv.canvasController.getFirstLayerGroups());
        } else if (name == "alignLeft") {
            canv.canvasController.alignSelected("left");
        } else if (name == "alignHCenters") {
            canv.canvasController.alignSelected("hCenters");
        } else if (name == "alignRight") {
            canv.canvasController.alignSelected("right");
        } else if (name == "alignTop") {
            canv.canvasController.alignSelected("top");
        } else if (name == "alignVCenters") {
            canv.canvasController.alignSelected("vCenters");
        } else if (name == "alignBottom") {
            canv.canvasController.alignSelected("bottom");
        } else if (name == "zoomToSelection") {
            canv.zoomToSelected();
        } else if (name == "zoomIn") {
            canv.actionManager.zoomPlus();
        } else if (name == "zoomOut") {
            canv.actionManager.zoomMinus();
        } else if (name == "navTrackpad") {
            canv.actionManager.setMode("trackpad");
            this.close();
        } else if (name == "navMouse") {
            canv.actionManager.setMode("mouse");
            this.close();
        } else if (name == "backToFiles") {
            window.location.href = canv.host + "/dashboard";
        }
    }

    placeImageProccessor() {
        var imageWidgetInput = document.getElementsByClassName(
            "settingsWindowItemImage",
        )[0];
        imageWidgetInput.click();

        imageWidgetInput.removeEventListener(
            "change",
            this.placeImageProccessorHelper,
            false,
        );
        imageWidgetInput.addEventListener(
            "change",
            this.placeImageProccessorHelper,
            false,
        );
    }

    placeImageProccessorHelper = (e) => {
        if (e.target.files.length === 0) {
            return;
        }
        return loadFiles(e.target.files, "center").then((newGroup) => {
            if (Array.isArray(newGroup) && newGroup.length > 0) {
                selectionManager.setSelected(newGroup);
            } else {
                canv.toolBox.switchTo(canv.toolBox.getFirstTool());
            }
        });
    };

    // unions

    getUnionByCodeName(codeName) {
        if (codeName == "start") {
            return this.getStartUnion();
        } else if (codeName == "edit") {
            return this.getEditUnion();
        } else if (codeName == "view") {
            return this.getViewUnion();
        } else if (codeName == "arrange") {
            return this.getArrangeUnion();
        } else if (codeName == "navigation") {
            return this.getNavigationUnion();
        }

        return [];
    }

    getStartUnion() {
        var startItems = [];

        if (!canv.isGrantedAccess() && canv.isBoardModeEditOrOwner())
            startItems.push(new settingsWindowItem(this.panelLevel, "backToFiles"));

        if (!canv.isBoardModeView()) {
            startItems.push(new settingsWindowItem(this.panelLevel, "edit"));
        }

        startItems.push(new settingsWindowItem(this.panelLevel, "view"));

        if (!canv.isBoardModeView()) {
            startItems.push(new settingsWindowItem(this.panelLevel, "arrange"));
        }

        startItems.push(new settingsWindowItem(this.panelLevel, "navigation"));

        if (!canv.isBoardModeView()) {
            startItems.push(new settingsWindowItem(this.panelLevel, "shortcuts"));
        }

        if (!canv.isGrantedAccess() && canv.isBoardModeEditOrOwner())
            startItems.push(new settingsWindowItem(this.panelLevel, "share"));

        if (!canv.isBoardModeView()) {
            startItems.push(new settingsWindowItem(this.panelLevel, "placeImage"));
        }

        return startItems;
    }

    getEditUnion() {
        var editItems = [];

        editItems.push(new settingsWindowItem(this.panelLevel, "undo"));
        editItems.push(new settingsWindowItem(this.panelLevel, "redo"));
        // editItems.push(new settingsWindowItem(this.panelLevel, "cut",));
        editItems.push(new settingsWindowItem(this.panelLevel, "copy"));
        editItems.push(new settingsWindowItem(this.panelLevel, "paste"));
        editItems.push(new settingsWindowItem(this.panelLevel, "selectAll"));

        return editItems;
    }

    getViewUnion() {
        var items = [];

        items.push(new settingsWindowItem(this.panelLevel, "zoomIn"));
        items.push(new settingsWindowItem(this.panelLevel, "zoomOut"));
        //items.push(new settingsWindowItem(this.panelLevel, "zoomTo100"));
        items.push(new settingsWindowItem(this.panelLevel, "zoomToSelection"));

        return items;
    }

    getArrangeUnion() {
        var items = [];

        items.push(new settingsWindowItem(this.panelLevel, "alignLeft"));
        items.push(new settingsWindowItem(this.panelLevel, "alignRight"));
        items.push(new settingsWindowItem(this.panelLevel, "alignHCenters"));
        items.push(new settingsWindowItem(this.panelLevel, "alignTop"));
        items.push(new settingsWindowItem(this.panelLevel, "alignVCenters"));
        items.push(new settingsWindowItem(this.panelLevel, "alignBottom"));

        return items;
    }

    getNavigationUnion() {
        var items = [];

        items.push(new settingsWindowItem(this.panelLevel, "navTrackpad"));
        items.push(new settingsWindowItem(this.panelLevel, "navMouse"));

        return items;
    }

    panelLevel = 0;
    items = [];
    parentItem = null;
    childPanel = null;
}
